module.exports = __webpack_public_path__ + "img/bolt.1cc977fe.svg";